import { UserData, UserResponse } from "@user/models";
import { buildDisplayName } from "@user/utils/buildDisplayName";
import { convertPreferencesArrayToMap } from "@user/utils/convertPreferencesArrayToMap";

export const normalizeUserResponse = (userResponse: UserResponse): UserData => {
  const preferences = convertPreferencesArrayToMap(userResponse.preferences);

  return {
    preferences,
    id: userResponse.userId,
    sfdcContactId: userResponse.sfdcContactId,
    userType: userResponse.userType,
    email: userResponse.email,
    name: buildDisplayName(userResponse.firstName, userResponse.lastName),
    external: userResponse.external,
    permissions: userResponse.permissions,
    segmentFunction: userResponse.segmentFunction,
    selectedAccountGroup: preferences.UserDefaultInvestorsGroup,
  };
};
